<!--
 * @Author: zhou.l
 * 零售-对等换货
-->
<template>
  <div class="ReciprocalExchange">
    <OmsButton :btn-config="btnConfig" />
    <OmsTable :jordan-table-config="table1"
              @on-row-click="onRowClick"
              @on-row-dblclick="onRowDblclick"
              @on-current-change="(n,o) => onCurrentChange(n,o,'table1')"
              @on-page-change="pageChange"
              @on-page-size-change="pageSizeChange" />
    <!-- 对等换货策略 -->
    <Modal v-model="orderModal"
           width="900"
           titleAlign="left"
           :closable="true"
           :mask="true"
           class-name="ark-dialog"
           :title="t('对等换货策略')">
      <div class="cus-modal">
        <div class="obj-table1">
          <OmsTable ref="currentRowTable"
                    :jordan-table-config="table2"
                    @on-row-click="onRowClick"
                    @on-row-dblclick="onRowDblclick"
                    @on-current-change="(n,o) => onCurrentChange(n,o,'table2')"
                    @on-page-change="pageChange"
                    @on-page-size-change="pageSizeChange" />
        </div>
      </div>
      <div class="dialog-footer"
           slot="footer">
        <OmsButton :btn-config="btnConfigMo" />
      </div>
    </Modal>
  </div>
</template>

<script>

export default {
  name: 'sourceBillNo',
  components: {},
  props: {
    componentData: {},
    value: {
      type: String,
      default: () => '', // 框架传过来的value
    },
  },
  data() {
    return {
      disabled: false,
      orderModal: false,
      loading: false,
      ID: this.$route.params.customizedModuleId && (this.$route.params.customizedModuleId != 'NEW' || this.$route.params.customizedModuleId != 'New') ? this.$route.params.customizedModuleId : '-1',
      getCurrenData: {},
      btnConfig: {
        typeAll: "default",
        btnsite: "left",
        buttons: [
          {
            text: t('返回'),
            btnclick: () => {
              this.$parent.$parent.closeConfirm();
            },
          },
          {
            text: t('对等换货策略'),
            type: 'primary',
            btnclick: async () => {
              const self = this
              const select1 = this.table1.selectionArr
              if (!select1.length) {
                this.$Message.warning(t('请选中一条单据！'));
                return false
              }
              const { sku_code } = select1[0]
              const demo = [
                {"exchange_sku_code":"23232323232","exchange_sku_title":"250ml牛奶","exchange_qty":2,"equal_sku_code":"23232323232","equal_sku_title":"250ml牛奶","equal_qty":1},
                {"exchange_sku_code":"23232323232","exchange_sku_title":"250ml牛奶","exchange_qty":2,"equal_sku_code":"23232323232","equal_sku_title":"250ml牛奶","equal_qty":1}
              ]
              const res = await self.service.orderCenter.selectEqualExchange({sku_code});
              if (res.data.code != 0) {
                return
              } else {
                this.table2.data = res.data.data
                this.orderModal = true;
              }
              // this.table2.data = demo
              // this.orderModal = true;
            },
          },
        ],
      },
      btnConfigMo: {
        typeAll: "default",
        btnsite: "right",
        buttons: [
          {
            text: t('返回'),
            btnclick: () => {
              this.orderModal = false;
              this.$refs.currentRowTable.$children[5].clearCurrentRow();
              this.table2.selectionArr = [];
            },
          },
          {
            text: t('确认执行'),
            type: 'primary',
            btnclick: () => {
              const self = this
              const select2 = this.table2.selectionArr
              if (!select2.length) {
                this.$Message.warning(t('请选中一条单据！'));
                return false
              }
              const row = Object.assign({}, select2[0], this.table1.selectionArr[0])
              self.service.orderCenter.confirmEqualExchange(row).then(res => {
                if (res.data.code === 0) {
                  if (res.data.data) {
                    window.dispatchEvent(new CustomEvent('addTask',{
                      detail: {
                        type: 'notice',
                      },
                    }))
                  } else {
                    this.$Message.success(res.data.message);
                  }
                  self.$parent.$parent.$parent.getData();
                }
              }).finally(e => {
                self.orderModal = false;
                self.table1.selectionArr = [];
                self.table2.selectionArr = [];
                self.$parent.close();
              });
            },
          },
        ],
      },
      table1: {
        columns: [
          {
            key: 'sku_code',
            title: t('SPU编码'),
          }, {
            key: 'sku_title',
            title: t('SPU名称')
          }, {
            key: 'qty',
            title: t('销售数量')
          },
        ], // 表头
        data: [], // 数据配置
        selectionArr: [],
        indexColumn: true, // 是否显示序号
        height: '300',
        loading: false,
        pageShow: false, // 控制分页是否显示
        btnsShow: false, // 控制操作按钮是否显示
        searchInputShow: false, // 控制搜索框是否显示
        total: 0, // 设置总条数
        pageSizeOpts: [10, 20, 30, 50, 100], // 每页条数切换的配置
        pageSize: 10, // 每页条数
        pageIndex: 1, // 页码
        isShowSelection: true, // 是否显示checkedbox
        highlightRow: true, // 高亮单选必须结合它
        multiple: false, //false 单选
      },
      table2: {
        columns: [
          {
            key: 'exchange_sku_code',
            title: t('换货商品')
          }, {
            key: 'exchange_sku_title',
            title: t('换货商品名称')
          }, {
            key: 'exchange_qty',
            title: t('换货数量')
          }, {
            key: 'equal_sku_code',
            title: t('对等商品')
          }, {
            key: 'equal_sku_title',
            title: t('对等商品名称')
          }, {
            key: 'equal_qty',
            title: t('对等数量')
          },
        ], // 表头
        data: [],
        selectionArr: [],
        indexColumn: true, // 是否显示序号
        height: '300',
        loading: false,
        pageShow: false, // 控制分页是否显示
        btnsShow: false, // 控制操作按钮是否显示
        searchInputShow: false, // 控制搜索框是否显示
        total: 0, // 设置总条数
        pageSizeOpts: [10, 20, 30, 50, 100], // 每页条数切换的配置
        pageSize: 10, // 每页条数
        pageIndex: 1, // 页码
        isShowSelection: true, // 是否显示checkedbox
        highlightRow: true, // 高亮单选必须结合它
        multiple: false, //false 单选
      },
    };
  },
  watch: {
    'componentData.orderDetails': {
      handler(v) {
        console.log('orderDetails::', v);
        this.table1.data = v
      },
      immediate: true,
    }
  },
  created() {
    console.log();
  },
  destroyed() {

  },
  mounted() {

  },
  methods: {
    /* --------------------- 工具函数： --------------------- */
    keyDown() { },
    /* ------------------- 事件 part start ------------------- */
    async queryEnter(pageNum = 1, pageSize = 10, enter) {
      const self = this;
      this.table1.loading = true;
      let formValue = this.table1.businessFormConfig.formValue;
      let paramsNull
      let params = {
        pageNum: pageNum,
        pageSize: pageSize,
        sku_code: formValue.sku_code || enter ? formValue.sku_code || enter : paramsNull,
        sku_title: formValue.sku_title ? formValue.sku_title : paramsNull,
        qty: formValue.qty ? formValue.qty : paramsNull,
        RECEIVER_NAME: formValue.RECEIVER_NAME ? formValue.RECEIVER_NAME : paramsNull,
        BUYER_NICK: formValue.BUYER_NICK ? formValue.BUYER_NICK : paramsNull,
        RECEIVER_MOBILE: formValue.RECEIVER_MOBILE ? formValue.RECEIVER_MOBILE : paramsNull,
      }
      const { data: { code, data } } = await self.service.orderCenter.queryExtraReturnOrder(params);
      this.table1.loading = false;
      if (code === 0) {
        this.table1.data = data.ORDER;
        this.table1.total = data.TOTAL;
        if (enter) {
          this.$emit('change', [{ ID: this.table1.data[0].sku_code }]);
        }
      }
    },
    onCurrentChange(n, o, tag) {
      const _this = this
      _this[tag].selectionArr.push(n)
    },
    onRowClick(row, index) {
      // 走了 onCurrentChange, 此处不必做处理
    },
    onRowDblclick(row) {
      const self = this;
    },
    pageChange(page) {
      this.table1.pageIndex = page;
      this.queryEnter(page, this.table1.pageSize)
    },
    pageSizeChange(size) {
      this.table1.pageSize = size;
      this.queryEnter(1, size)
    }
    /* ------------------- 子表事件 part end ------------------- */
  },
};

</script>

<style lang="less" scoped>
</style>
